import { Box, Flex, Group } from "@mantine/core";
import { AgGridReact } from "ag-grid-react";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { DEVICE_DISCIPLINE_MAPPING, DisciplineEnum } from "../../enums";
import DeviceIcon from "../../SelectedSpace/DeviceIcon";
import { HOTKEYS } from "../../constants";

const HelpPanel = () => {
  return (
    <Box className="ag-theme-quartz">
      <DeviceTypeTable />
      <HotkeyTable />
    </Box>
  );
};

export default HelpPanel;

const DeviceTypeTable: React.FC = () => {
  const rows = Object.entries(DEVICE_DISCIPLINE_MAPPING)
    .map(([key, value]) => {
      return {
        discipline: value,
        deviceCategory: key,
      };
    })
    .filter((item) => item.discipline !== DisciplineEnum.ARCHITECTURE);

  const columns: ColDef[] = [
    {
      field: "deviceCategory",
      headerName: "Kategori",
      cellRenderer: (params: ICellRendererParams) => (
        <Group>
          <Flex align="center">
            <DeviceIcon deviceType={params.data?.deviceCategory} />
            <span>{params.value}</span>
          </Flex>
        </Group>
      ),
    },
    {
      field: "discipline",
      headerName: "Disiplin",
    },
  ];
  return (
    <Box className="ag-theme-quartz">
      <h3>Produkttyper</h3>
      <AgGridReact
        domLayout="autoHeight"
        columnDefs={columns}
        rowData={rows ?? []}
        getRowId={(p) => p.data.deviceCategory as string}
      />
    </Box>
  );
};

const HotkeyTable: React.FC = () => {
  const rows = Object.entries(HOTKEYS).map(([key, value]) => {
    return {
      action: key,
      shortkey: value,
    };
  });

  const columns: ColDef[] = [
    {
      field: "action",
      headerName: "Handling",
    },
    {
      field: "shortkey",
      headerName: "Hurtigtaster",
    },
  ];
  return (
    <Box className="ag-theme-quartz" style={{ height: "400px", overflow: "auto" }}>
      <h3>Hurtigtaster</h3>
      <AgGridReact
        columnDefs={columns}
        rowData={rows ?? []}
        getRowId={(p) => p.data.deviceCategory as string}
      />
    </Box>
  );
};
